import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';

interface SearchProps {
  onSearch?: (query: string) => void;
}
const Search: React.FC<SearchProps> = ({ onSearch }) => {
  const { t } = useTranslation();

  const search = async (query: string) => {
    onSearch && onSearch(query);
  };
  const debounce = (func: Function, delay: number) => {
    let timeoutId: NodeJS.Timeout;
    return (...args: any) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func(...args), delay);
    };
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSearch = useCallback(debounce(search, 500), [onSearch]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newQuery = event.target.value;
    debouncedSearch(newQuery);
  };

  return (
    <div className="search-box search-box-sm">
      <input
        type="text"
        className="form-control bg-light border-0"
        id="searchClientCompany"
        placeholder={t('ClientsDashboard.dashboard.search')}
        onChange={handleChange}
      />
      <i className="ri-search-line search-icon" />
    </div>
  );
};
export default Search;
